/**
*  Get Block Image.
*
* @param {String} colClassName ClassName
* @returns {Array} Block column.
*/
export const blockColumns = [
	[
		'core/image',
		{
			className: 'page__content-figure',
			align: 'full',
			caption: false
		},
	],
]; 